module.exports = {
  apiUrl: "https://sendonet-dev.fyi",
  apiKey: "03FgDmCIC3eYFfvd",
};
